export const namespace = 'users';

export const MutationTypes = {
  SET_USER: 'SET_USER',
  SET_USERS: 'SET_USERS',
  SET_USER_HISTORY: 'SET_USER_HISTORY',
  SET_USERS_NAMES_AUTOCOMPLETE: 'SET_USERS_NAMES_AUTOCOMPLETE',
  SET_USERS_EMAILS_AUTOCOMPLETE: 'SET_USERS_EMAILS_AUTOCOMPLETE',
};

export const ActionTypes = {
  GET_USER: 'GET_USER',
  GET_USERS: 'GET_USERS',
  GET_USER_HISTORY: 'GET_USER_HISTORY',
  GET_USERS_NAMES_AUTOCOMPLETE: 'GET_USERS_NAMES_AUTOCOMPLETE',
  GET_USERS_EMAILS_AUTOCOMPLETE: 'GET_USERS_EMAILS_AUTOCOMPLETE',
};
